/**
 * Pure rules for login: scope validation, OAuth error mapping and the benefits heading.
 */

export function getBenefitsHeadingId(isKalamaBranding: boolean): string {
  return isKalamaBranding ? 'login.benefits.headingKalama' : 'login.benefits.heading'
}

export function checkScopes(requiredScopes: string, codeResponse: { scope: string }): boolean {
  const required = requiredScopes.split(' ')
  const received = codeResponse.scope.split(' ')
  return required.every((scope) => received.includes(scope))
}

export function getOAuthErrorCode(error: string): number {
  return error === 'access_denied' ? 403 : 404
}
